import { StoreColumnExtractor } from './store-column-extractor';

export class SimpleExtractor implements StoreColumnExtractor {
	constructor(public readonly storeConfig: any[], public readonly transform: (...storeConfigs: any[]) => any) {}
	public storeConfigDependencies(): any[] {
		return this.storeConfig;
	}
	public extractor(): (storeData: any[]) => any {
		return this.transform;
	}

	public getDataPointPath(): string {
		return this.storeConfig.toString();
	}
}
